import { cn } from '@/libs/utils';

// ? INFO: source of icons is "react-world-flags" packages
// import Flag from 'react-world-flags';
// * USE THIS: <Flag code="RU" />

export default function CurrencyBadge({ className, currency, currencyCode }) {
  const icon = (
    <img
      src={`/assets/icons/flags/${currencyCode}.svg`}
      alt={currencyCode}
      title={currencyCode}
      className="block h-full object-contain"
    />
  );

  return (
    <span
      title={currencyCode}
      className={cn(
        'relative z-[0] mt-5 flex h-7 cursor-default items-center justify-center gap-2 overflow-hidden rounded-[4px] border border-[#d9d9d9] bg-white px-2 text-[11px] font-semibold',
        className
      )}
    >
      <span
        className="absolute -z-[1] block w-full opacity-30"
        style={{ filter: 'blur(10px)', backgroundColor: 'transparent' }}
      >
        {icon}
      </span>

      <span className="mb-[1px] block h-3 w-5">{icon}</span>

      <span className="text-black">{currency}</span>
    </span>
  );
}
